import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-navbar-vertical',
    templateUrl: './navbar-vertical.component.html',
    styleUrls: ['./navbar-vertical.component.scss'],
    standalone: false
})
export class NavbarVerticalComponent implements OnInit {
  haySesionActiva: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
